import type React from 'react';

import { usePetitionDetailsPageData, usePetitionDetailsPageUserData } from '#src/app/pages/petitionDetails/pageContext';
import { useSapCtaTracking } from '#src/app/pages/petitionDetails/shared/hooks';

import { SapCta as SapCtaView } from './components/SapCta';

export const SapCta: React.FC<EmptyProps> = () => {
	const {
		data: {
			featureConfigs: { sapCtaEnabled },
		},
	} = usePetitionDetailsPageData();
	const {
		data: { canEdit, signed },
	} = usePetitionDetailsPageUserData();
	const { trackClick } = useSapCtaTracking();

	if (canEdit || !sapCtaEnabled || !signed) return null;

	return (
		<div className="mt-6 mb-20">
			<SapCtaView onClick={trackClick} />
		</div>
	);
};
